import { Validators } from "@angular/forms";
import { required } from "@corporate-tailwind/corp-form";

export class OrderGtcDto {
    isGtcAccepted: boolean | null = false;
}

export class OrderGtcSchema extends OrderGtcDto {
    static schema = {
        isGtcAccepted: { type: Boolean, builderOption: { validators: [Validators.required], defaultDisabled: true, defaultValue: false }},
    };

}